export default [
  config => {
    config.headers.Brand = 'sjsj_web'
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  },
]
